import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'selectReading',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,

      search: {
        readingNumber: null,
        reading: null,
        fromDate: null,
        toDate: null,
      },

      appData: {
        readingNumber: 0,
        fromDate: null,
        toDate: null,
        reading: 0
      },
      lang: '',
      readOnly: false,
      fromDateView: null,
      toDateView: null,

      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      readingsCols: [],
      readings: [],
      noDataFound: false,
      keyColumn: 'readingNumber',
      meterId: -1,
      readingNumber: 0,
      selectedReading: {},
      readingDateView: null
    }
  },
  created() {
    console.log(this.dataObj);
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('select_reading_updated', this.init);
    this.fillReadingsCol();
    this.init();
  },
  watch: {
    fromDateView: function (val) {
      this.appData.fromDate = moment(val, "DD/MM/YYYY").add(1, 'days');
    },
    toDateView: function (val) {
      this.appData.toDate = moment(val, "DD/MM/YYYY").add(1, 'days');
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('DD/MM/YYYY');
    }
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
        this.fromDateView = this.$options.filters.formatDateDDMMYYY(this.appData.fromDate);
        this.toDateView = this.$options.filters.formatDateDDMMYYY(this.appData.toDate);
        this.readOnly = this.dataObj.readOnly;
      });
    },
    moment: function () {
      return moment();
    },
    getReadings() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Filters: this.search,
        Options: this.options
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/SelectReadingActivity/GetReadings', parameter),
        response => {
          if (response.status == 200) {
            if (response.data.items.length == 0) {
              this.readings = [];
              this.noDataFound = true;
            }
            else {
              this.readings = response.data.items;
              this.options.total = response.data.itemsCount;
              this.totalRow = response.data.itemsCount;
            }
            this.$root.$emit('datagrid_updated');
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/SelectReadingActivity/GetReadings', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      console.log(response.data);

      //      if (response.data.items.length == 0) {
      //        this.readings = [];
      //        this.noDataFound = true;
      //      }
      //      else {
      //        this.readings = response.data.items;
      //        this.options.total = response.data.itemsCount;
      //        this.totalRow = response.data.itemsCount;
      //      }
      //      this.$root.$emit('datagrid_updated');
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.data);
      //  });
    },
    resetFilters() {
      this.search.readingNumber = null;
      this.search.reading = null;
      this.search.fromDate = null;
      this.search.toDate = null;
    },
    onSelectReading(info) {
      if (info.newRowIndex < 0)
        return;

      var read = info.rows[info.newRowIndex].data;
      if ((read === null) || (read === undefined))
        return;

      console.log(read);

      this.selectedReading = read;
      this.readingDateView = moment(read.readingDate).format('DD/MM/YYYY');

      this.readingNumber = read.readingNumber;
      this.dataObj.meterId = read.meterId;
      this.dataObj.readingNo = read.readingNumber;
    },
    selectReading() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        meterId: this.meterId,
        readingNumber: this.readingNumber,
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/SelectReadingActivity/SelectReading', parameter),
        response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.SelectReadingSuccess'), 2);
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/SelectReadingActivity/SelectReading', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.$alertMsg(this.$t('messages.SelectReadingSuccess'), 0);
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.data);
      //  });
    },
    pageChange(pInfo) {
      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getReadings();
    },
    fillReadingsCol() {
      this.readingsCols.push({ dataField: 'readingNumber', caption: this.$t('activities.readingNo') });
      this.readingsCols.push({ dataField: 'meterRef', caption: this.$t('activities.meterRef') });
      this.readingsCols.push({ dataField: 'readingDate', caption: this.$t('activities.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.readingsCols.push({ dataField: 'reading', caption: this.$t('activities.reading') });
      this.readingsCols.push({ dataField: 'consumption', caption: this.$t('activities.consumption') });
      this.readingsCols.push({ dataField: 'flow', caption: this.$t('activities.flow') });
      this.readingsCols.push({ dataField: 'typeDescription', caption: this.$t('activities.type') });
      this.readingsCols.push({ dataField: 'reasonDescription', caption: this.$t('activities.readReason') });
      this.readingsCols.push({ dataField: 'methodDescription', caption: this.$t('activities.readMethod') });
      this.readingsCols.push({ dataField: 'clockOver', caption: this.$t('activities.clockOver'), dataType: 'boolean' });
      this.readingsCols.push({ dataField: 'isInvoiced', caption: this.$t('activities.billed'), dataType: 'boolean' });
      this.readingsCols.push({ dataField: 'invoiceDate', caption: this.$t('activities.billingDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.readingsCols.push({ dataField: 'meterReader', caption: this.$t('activities.meterReader') });
      this.readingsCols.push({ dataField: 'comment', caption: this.$t('activities.comment') });
    },
    completeTask() {
      this.dataObj.completeTask();
    }
  },
}

